import { create, get } from "@github/webauthn-json";

const PASSKEY_PREFERENCE_KEY = "preferPasskey";

const PASSKEY_PREFERENCE_TTL = 1000 * 60 * 60 * 24 * 30; // 30 days

export function getPasskeyPreference() {
  try {
    const stored = localStorage.getItem(PASSKEY_PREFERENCE_KEY);
    if (!stored) {
      return null;
    }

    const parsed = JSON.parse(stored);
    if (!parsed.email || !parsed.lastSuccessfulAt) {
      return null;
    }

    const expired = Date.now() - parsed.lastSuccessfulAt > PASSKEY_PREFERENCE_TTL;
    if (expired) {
      localStorage.removeItem(PASSKEY_PREFERENCE_KEY);
      return null;
    }

    return parsed;
  } catch (error) {
    console.warn("Unable to read passkey preference", error);
    return null;
  }
}

export function setPasskeyPreference(email) {
  if (!email) {
    return;
  }

  try {
    localStorage.setItem(
      PASSKEY_PREFERENCE_KEY,
      JSON.stringify({ email, lastSuccessfulAt: Date.now() })
    );
  } catch (error) {
    console.warn("Unable to store passkey preference", error);
  }
}

export function clearPasskeyPreference() {
  try {
    localStorage.removeItem(PASSKEY_PREFERENCE_KEY);
  } catch (error) {
    console.warn("Unable to clear passkey preference", error);
  }
}

window.webauthnAuthenticate = function (opts) {
  return get({ publicKey: opts })
    .then((credential) => {
      // console.log(credential);
      // window.credentialDebug = credential;

      if (!credential) {
        return; // failed
      }

      const credentialInput = document.getElementById('public_key_credential_json');
      const form = document.getElementById('webauthn-form');

      if (!credentialInput || !form) {
        return;
      }

      const emailField = form.querySelector("input[name='user[email]']");
      if (emailField && emailField.value) {
        setPasskeyPreference(emailField.value);
      }

      credentialInput.value = JSON.stringify(credential);
      form.submit();

      return credential;
    })
    .catch((error) => {
      console.warn("Webauthn authentication failed", error);
      clearPasskeyPreference();
      throw error;
    });
};

window.webauthnRegister = function (form, opts) {
  create({ publicKey: opts })
    .then((newCredentialInfo) => {
      // console.log(newCredentialInfo)
      document.getElementById('public_key_credential_json').value = JSON.stringify(newCredentialInfo);

      // now that the form is complete, submit it form for real
      form.submit();
    });
};
